module.exports = __webpack_public_path__ + "fdc5bf492fa5a7538f74ab8bee2cfdbf.MP3";